import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { SystemService } from "src/app/system/system.service";
import { System, SystemsEntity } from "src/app/system/system";
import { MatSnackBar } from "@angular/material";
import { AuthService } from "src/app/auth.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-system",
  templateUrl: "./system.component.html",
  styleUrls: ["./system.component.css"],
})
export class SystemComponent implements OnDestroy {
  private subscription$ = new Subscription();
  showLoader: boolean = true;

  constructor(
    private systemService: SystemService,
    private snackBar: MatSnackBar,
    public auth: AuthService,
    private route: ActivatedRoute,

  ) {}

  searchSystem: string | number | any | null;
  systems: SystemsEntity[];
  mode = 0;

  ngOnInit() {
    this.auth.userProfileSubject$.subscribe(
      (profile) => {
        if (profile) {
          this.getSystemsList();
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackBar.open(
          `Error in Getting Designer and Contractor Details`,
          "",
          {
            duration: 2000,
          }
        );
      }
    );


    this.route.queryParams.subscribe((queryParams: any) => {
      if (queryParams?.mode) {

        this.mode = queryParams.mode;

      }
    });


  }

  /**
   * Get Systems List
   */
  getSystemsList() {
    this.showLoader = true;
    this.subscription$.add(
      this.systemService.getSystemList().subscribe(
        (result: System) => {
          this.systems = result.systems;
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting System List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  addSystemToDesign() {



  }


  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
